class ColorSwatch extends HTMLElement {
	constructor() {
		super();

		this.cached = {};
		this.variantId = this.dataset.variantId;
		this.container = this.closest('.mm-product-card');

		// Ajouter un écouteur pour le slider
		const sliderPrevButton = this.container.querySelector('.mm-pc-slider-prev');
		const sliderNextButton = this.container.querySelector('.mm-pc-slider-next');
		
		if (sliderPrevButton) {
			sliderPrevButton.addEventListener('click', () => this.handleSliderChange());
		}
		if (sliderNextButton) {
			sliderNextButton.addEventListener('click', () => this.handleSliderChange());
		}

		if (this.variantId) {
			this.addEventListener('click', this.onHoverHandler.bind(this));
		} else {
			this.addEventListener('click', this.onHoverHandler.bind(this));
		}
	}

	onHoverHandler() {
		this.container.querySelector('.mm-product-card-colors-container').classList.add('loading');
		if (this.variantId) {
			this.colorSwatchFetch();
		} else {
			this.colorSwatchChange();
		}
	}

	colorSwatchChange(forceUpdate) {
		const image = this.container.querySelector('.mm-pc-image-1');
		const imageHover = this.container.querySelector('.mm-pc-image-2');
		const sliderImages = this.container.querySelectorAll('.mm-pc-slider-image');

		if (image !== null || forceUpdate) {
			if (image !== null) {
				image.src = this.dataset.imageSrc;
				image.srcset = this.dataset.imageSrc;
			}
		}
		if (imageHover != null || forceUpdate) {
			if (imageHover !== null) {
				imageHover.src = this.dataset.imageHoverSrc;
				imageHover.srcset = this.dataset.imageHoverSrc;
			}
		}

		// Mise à jour de TOUTES les images du slider
		if (sliderImages.length > 0) {
			sliderImages.forEach((sliderImage, index) => {
				if (index % 2 === 0) {
					// Images paires : image principale
					sliderImage.src = this.dataset.imageSrc;
					sliderImage.srcset = this.dataset.imageSrc;
				} else {
					// Images impaires : image hover
					sliderImage.src = this.dataset.imageHoverSrc;
					sliderImage.srcset = this.dataset.imageHoverSrc;
				}
			});
		}

		const swatches = this.container.querySelectorAll('.mm-product-card-color-swatch');
		swatches.forEach((swatch) => {
			swatch.classList.remove('is-active');
		});

		this.classList.add('is-active');

		this.updateProductLinks(this.dataset.productHandle);
		this.updateSizeVariants(this.dataset.variantId, this.dataset.productHandle);
		this.updatePrice(this.dataset.price, this.dataset.compareAtPrice);
	}

	updateProductLinks(dataHandle) {
		const cardLinks = this.container.querySelectorAll('a');
		this.container.dataset.url = `/products/${dataHandle}`;
		let sectionUrl = `/products/${dataHandle}`;
		cardLinks.forEach((link) => {
			link.href = sectionUrl;
		});
	}

	updateSizeVariants(variantId, productHandle) {
		const sizeVariants = this.container.querySelectorAll(".mm-pc-sizes");
		sizeVariants.forEach((variantContainer) => {
			if (variantContainer.dataset.variantId === variantId) {
				variantContainer.style.display = 'block';  // Show matching size variants

				// Update URL for each size variant link
				const sizeLinks = variantContainer.querySelectorAll('a');
				sizeLinks.forEach((link) => {
					const variantSpecificId = link.dataset.variantId;
					link.href = `/products/${productHandle}?variant=${variantSpecificId}`;
				});
			} else {
				variantContainer.style.display = 'none';  // Hide non-matching size variants
			}
		});
	}

	colorSwatchFetch() {
		const productHandle = this.dataset.productHandle;
		// let sectionUrl = `/products/${productHandle}?variant=${this.variantId}&view=card`;
		let sectionUrl = `/products/${productHandle}`;

		// remove double `/` in case shop might have /en or language in URL
		sectionUrl = sectionUrl.replace('//', '/');

		if (this.cached[sectionUrl]) {
			this.renderProductInfo(this.cached[sectionUrl]);
			return;
		}

		fetch(sectionUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				this.cached[sectionUrl] = html;
				this.renderProductInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderProductInfo(html) {
		this.colorSwatchChange(true);
		this.updateElement('.mm-pc-title', html);
		this.updateElement('.mm-product-card-price', html);
		this.updateElement('.mm-product-card-button-container', html);
		this.removeLoading();
	}

	/**
	 *
	 * @param {string} selector
	 * @param {HtmlElement} html
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	removeLoading() {
		this.container.querySelector('.mm-product-card-colors-container').classList.remove('loading');
	}

	updatePrice(price, compareAtPrice) {
		const priceContainer = this.container.querySelector('.mm-pc-price-container');
		if (priceContainer) {
			let priceHTML = `<p>${this.formatPrice(price)}</p>`;
			if (compareAtPrice && compareAtPrice > price) {
				priceHTML += `<s class="mm-text-x-small mm-old-price">${this.formatPrice(compareAtPrice)}</s>`;
			}
			priceContainer.innerHTML = priceHTML;
		}
	}

	formatPrice(price) {
		return (price / 100).toFixed(2).replace('.', ',') + '€';
	}

	// Nouvelle méthode pour gérer le changement de slide
	handleSliderChange() {
		// Trouver le swatch actif
		const activeColorSwatch = this.container.querySelector('.mm-product-card-color-swatch.is-active');
		if (activeColorSwatch) {
			// Récupérer les images actuelles du swatch actif
			const mainImage = activeColorSwatch.dataset.imageSrc;
			const hoverImage = activeColorSwatch.dataset.imageHoverSrc;

			// Mettre à jour les images du slider avec les bonnes images
			const sliderImages = this.container.querySelectorAll('.mm-pc-slider-image');
			if (sliderImages.length > 0) {
				sliderImages[0].src = mainImage;
				sliderImages[0].srcset = mainImage;
				
				if (sliderImages[1]) {
					sliderImages[1].src = hoverImage;
					sliderImages[1].srcset = hoverImage;
				}
			}
		}
	}
}

customElements.define('color-swatch', ColorSwatch);
